import type { HelpStep } from "newui/components/ui/Help";

/**
 * PRO-757 (D10-T3) — the "What do I do?" trigger rendered INSIDE
 * `AddAccessFlow` itself (`data-testid="manage-roles-help"`), above the role
 * picker. Unlike the page-level topics in `userManagementTopics.tsx`, this
 * tour never navigates anywhere or injects a dummy user — it explains the
 * screen the admin already has open, against whichever real user(s) they're
 * adding access for. All five targets are part of the flow's FIRST (mode)
 * step, so no `onBeforeStep`/`onAfterStep` side effects are needed.
 */
export const buildAddAccessHelpSteps = (): HelpStep[] => [
	{
		target: '[data-testid="role-select"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Pick a role</h3>
				<p>
					Only roles this user (or all of the selected users) don&apos;t already hold
					company-wide are listed here.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[data-testid="mode-card-manual_panel"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Company Wide Access</h3>
				<p>Grants the role everywhere — every portfolio, project and RFx, now and in the future.</p>
			</div>
		),
		placement: "top",
		disableBeacon: true,
	},
	{
		target: '[data-testid="mode-card-manual_solo"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Specific Access</h3>
				<p>
					Picks exactly which portfolios, projects or RFx events the role applies to. Tap the
					(?) next to the search box on that screen for more on how picks cascade.
				</p>
			</div>
		),
		placement: "top",
		disableBeacon: true,
	},
	{
		target: '[data-testid="wizard-next"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Next</h3>
				<p>
					Company Wide takes you straight to a confirmation screen; Specific takes you to the
					scope picker first.
				</p>
			</div>
		),
		placement: "top",
		disableBeacon: true,
	},
];
